export type DisplayMode =
  | 'unified'             // All item types with filter
  | 'project_centric'     // Projects > Jobs > Tasks
  | 'job_centric'         // Jobs with subtasks
  | 'task_centric'        // Simple task list
  | 'appointment_centric' // Schedule-driven
  | 'route_centric'       // Route stops (logistics)
  | 'ticket_centric'      // Service desk
  | 'inspection_centric'  // Audits & inspections
  | 'today_focused';      // Today's work only

export const DEFAULT_SMART_TASK_DISPLAY_MODE: DisplayMode = 'unified';

const LEGACY_COMBINATION_DISPLAY_MODE = 'combination';

export function isSmartTaskDisplayMode(value: unknown): value is DisplayMode {
  return value === 'unified'
    || value === 'project_centric'
    || value === 'job_centric'
    || value === 'task_centric'
    || value === 'appointment_centric'
    || value === 'route_centric'
    || value === 'ticket_centric'
    || value === 'inspection_centric'
    || value === 'today_focused';
}

export function normalizeSmartTaskDisplayMode(
  value: unknown,
  fallback: DisplayMode = DEFAULT_SMART_TASK_DISPLAY_MODE,
): DisplayMode {
  if (value === LEGACY_COMBINATION_DISPLAY_MODE) {
    return DEFAULT_SMART_TASK_DISPLAY_MODE;
  }

  return isSmartTaskDisplayMode(value) ? value : fallback;
}

export function resolveSmartTaskDisplayMode(...values: unknown[]): DisplayMode {
  for (const value of values) {
    if (value === LEGACY_COMBINATION_DISPLAY_MODE) {
      return DEFAULT_SMART_TASK_DISPLAY_MODE;
    }

    if (isSmartTaskDisplayMode(value)) {
      return value;
    }
  }

  return DEFAULT_SMART_TASK_DISPLAY_MODE;
}
